import { sharedTranslations } from 'translations';

const placesMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: sharedTranslations.ng_shared_places,
        linkTitle: 'Places',
        icon: 'onsolve-locations-icon',
        routeTo: '/places',
        isRenderable: true,
        featureName: 'predifinedLocations',
        accessConfiguration: permissions => permissions.canViewPredefinedLocations()
    };
}

export default placesMenuItems;
